/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import { Select, Icon, Spin, Empty } from "antd";
import postService from "../../../services/httpService";
import networkList from "../../../constants/networkList";

const { Option } = Select;

class Select2search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      select2options: [],
      loading: false,
      selectdata: {},
      fetching: true,
    };
  }
  componentDidMount() {
    this.setState(
      (state) => ({ selectdata: this.props.selectdata }),
      () => {
        this.loadPage("");
      }
    );
  }

  // componentDidUpdate(prevProps, pervState) {
  //     if (prevProps.selectdata.value != this.props.selectdata.value) {
  //         // if (this.props.selectdata.value) {
  //         this.setState((state) => ({ 'selectdata': this.props.selectdata }));
  //     }
  // }

  onFocus() {
    this.loadPage("");
  }

  loadPage = (serch_key) => {
    const { master_unit, master_doctor } = networkList;

    this.setState({ fetching: true, select2options: [] });

    if (this.props.selectdata.name === "unit_id") {
      postService(master_unit, "GET", "null").then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.name;
            res["data"][key]["id"] = data.id;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "block_id") {
      let unit = this.getFormValue("unit_id");
      postService("blocksList", "GET", "null").then((res) => {
        if (res) {
          let new_array = [];
          res.data.map((data, key) => {
            if (unit === data.unit_name) {
              let obj = {
                id: data.block_id,
                name: data.block_name,
              };
              new_array.push(obj);
            }
          });
          this.setState((state) => ({
            select2options: new_array,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "floor_id") {
      let unit = this.getFormValue("unit_id");
      let block = this.getFormValue("block_id");
      postService("floorsList", "GET", "null").then((res) => {
        if (res) {
          let new_array = [];
          res.data.map((data, key) => {
            if (unit === data.unit_name && block === data.block_name) {
              let obj = {
                id: data.floor_id,
                name: data.floor_name,
              };
              new_array.push(obj);
            }
          });
          this.setState((state) => ({
            select2options: new_array,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "ot_id") {
      let payload = { page_no: 1 };
      let block = this.getFormValue("block_id");
      let floor = this.getFormValue("floor_id");

      postService("OTRoomsList", "POST", payload).then((res) => {
        if (res) {
          let new_array = [];
          res.data.map((data, key) => {
            if (floor === data.floor_name && block === data.block_name) {
              let obj = {
                id: data.ot_id,
                name: data.ot_name,
              };
              new_array.push(obj);
            }
          });
          this.setState((state) => ({
            select2options: new_array,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }

    if (this.props.selectdata.name === "doctor_id") {
      let payload = {
        data_count: 0,
        search_key: serch_key,
      };

      postService(master_doctor, "POST", payload).then((res) => {
        if (res) {
          res.data.map((data, key) => {
            res["data"][key]["name"] = data.name;
          });
          this.setState((state) => ({
            select2options: res.data,
            loading: false,
            fetching: false,
          }));
        } else {
          this.setState({ fetching: false });
        }
      });
    }
  };

  getFormValue(feild) {
    let { Queuedata } = this.props;
    let value = null;
    Queuedata.map((data) => {
      if (data.name === feild) {
        value = data.label;
      }
    });
    return value;
  }
  handleChange = (value, label) => {
  
    let { selectdata } = this.state;
    this.props.onselectChanges({
      name: selectdata.name,
      value: value,
      label: label.props.children,
    });
  };

  allowClear = (value, label) => {
    let { selectdata } = this.state;
    this.props.onselectChanges({
      name: selectdata.name,
      value: null,
      label: label.props.children,
    });
  };

  render() {
    // let { selectdata, select2options, fetching } = this.state;
    let { select2options, fetching } = this.state;
    let { selectdata } = this.props;
  
    return (
      <Select
        mode="single"
        value={
          selectdata && selectdata.value
            ? selectdata.value
            : selectdata.placeholder
        }
        showSearch={selectdata.showSearch}
        allowClear={false}
        placeholder={selectdata.placeholder}
        notFoundContent={
          fetching ? (
            <Spin size="small" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        filterOption={false}
        disabled={selectdata.disabled}
        onSearch={(search_key) => this.loadPage(search_key)}
        onChange={(value, label) => this.handleChange(value, label)}
        onClear={(value, label) => this.allowClear(value, label)}
        onFocus={this.onFocus.bind(this)}
        style={{ width: "100%" }}
      >
        {select2options.map((d) => (
          <Option key={d.id}>{d.name}</Option>
        ))}
      </Select>
    );
  }
}

export default Select2search;
